import React, { memo, useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Container, Grid, Paper, CircularProgress } from '@material-ui/core';
import ReactTable from 'Components/ReactTable/ReactTable';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { FormikMaterialSwitch } from 'Components/Inputes/FormikMaterialSwitch';
import { scrollToTop } from 'Components/utils.js';
import { LOGOUT } from 'ConstComponents';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import {
    Select as SELECT,
    SelectByID as SELECT_BY_ID,
    Update as UPDATE
} from 'Components/Api/CIBILScoreAPI';
import HOCLoader from 'Components/Loader/HOCLoader';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
const CustomContainer = HOCLoader(Container);

export const Index = memo(() => {
    const classes = commonStyle();
    const [itemList, setItemList] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [IsUpdate, setIsUpdate] = useState(false);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [responseMessage, setResponseMessage] = useState('');
    const [FormObj, setFormObj] = useState({
        CIBILScoreSettingID: 0,
        Name: '',
        MerchantID: '',
        Token: '',
        Slat: 0,
        PublicKey: '',
        IsActive: false,
        Mode: '',
        MinimumAmount: 0,
        MaximumAmount: 0
    });

    const FormValidationSchema = Yup.object({
        Name: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        MerchantID: Yup.string().required(PLEASE_PROVIDE_VALID + ' MerchantID'),
        Token: Yup.string().required(PLEASE_PROVIDE_VALID + ' token'),
        PublicKey: Yup.string().required(PLEASE_PROVIDE_VALID + ' PublicKey')
    });

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setResponseMessage('');
        var requestObj = JSON.stringify(values);
        setLoadingOpen(true);
        var response = await UPDATE(requestObj);
        if (!response.isAuthorized) LOGOUT();
        setLoadingOpen(false);
        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }
        setLoadingOpen(false);
        setIsError(true);
        setSeverity('success');
        setResponseMessage(response.data);
        resetForm(FormObj);

        setFormObj({
            CIBILScoreSettingID: 0,
            Name: '',
            MerchantID: '',
            Mode: '',
            Token: '',
            PublicKey: '',
            IsActive: false,
            Slat: 0,
            MinimumAmount: 0,
            MaximumAmount: 0
        });

        selectData();
    };

    useEffect(() => {
        createColumns();
        selectData();
    }, []);
    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'CIBILScoreSettingID',
            srno: true
        });

        columns.push({
            label: 'Edit',
            name: 'CIBILScoreSettingID',
            edit: true,
            callback: (CIBILScoreSettingID) => {
                setIsUpdate(true);
                SelectByID(CIBILScoreSettingID);
            }
        });

        columns.push({
            label: 'Name',
            name: 'Name',
            actived: true
        });

        columns.push({
            label: 'MerchantID',
            name: 'MerchantID',
            displayAsPassword: true
        });

        columns.push({
            label: 'Slat',
            name: 'Slat',
            actived: true
        });
        columns.push({
            label: 'Token',
            name: 'Token',
            displayAsPassword: true
        });
        columns.push({
            label: 'PublicKey',
            name: 'PublicKey',
            displayAsPassword: true
        });
        columns.push({
            label: 'MinimumAmount',
            name: 'MinimumAmount',
            actived: true
        });
        columns.push({
            label: 'MaximumAmount',
            name: 'MaximumAmount',
            actived: true
        });
        columns.push({
            label: 'Mode',
            name: 'Mode',
            actived: true
        });
        columns.push({
            label: 'Active',
            name: 'IsActiveStr',
            actived: true
        });
        setMainColumns(columns);
    };

    const selectData = async () => {
        setLoadingOpen(false);
        const response = await SELECT();
        if (!response.isAuthorized) LOGOUT();
        setLoadingOpen(false);

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);
        setItemList(data);
    };

    const SelectByID = async (CIBILScoreSettingID) => {
        setIsError(false);

        let jsonObj = {
            CIBILScoreSettingID: CIBILScoreSettingID
        };
        const response = await SELECT_BY_ID(JSON.stringify(jsonObj));
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        const { data, status } = response;
        if (!status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(data);
        }

        let d = JSON.parse(data);
        setFormObj({
            CIBILScoreSettingID: d.CIBILScoreSettingID,
            Name: d.Name,
            MerchantID: d.MerchantID,
            Token: d.Token,
            Slat: d.Slat,
            PublicKey: d.PublicKey,
            IsActive: d.IsActive,
            MinimumAmount: d.MinimumAmount,
            MaximumAmount: d.MaximumAmount,
            Mode: d.Mode
        });
        scrollToTop();
    };
    const OnChange = (name, value, setFieldValue) => {
        setFieldValue(name, value);
    };

    // const dmtContentMap = {
    //     PayPoint: (
    //         <label>
    //             <h3 className={classes.Provider_Format}>
    //                 <strong>PayPoint</strong> :{' '}
    //                 <span className={classes.normalTextColor}>
    //                     use <b>[AppID]</b> = PartnerID, <b>[AuthKey]</b> =
    //                     PublicKey,
    //                     <b>[SecretKey]</b> = ScreatKey and <b>[Mode]</b> = Mode
    //                 </span>
    //             </h3>
    //         </label>
    //     )
    // };
    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <h2 className={classes.PaperHead_h2}>
                        CIBILSCORE Setting{' '}
                    </h2>
                </Grid>
                <Grid item xs={6}></Grid>
            </Grid>
            <Formik
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={FormObj}
            >
                {(formProps) => {
                    return (
                        <Form
                            style={{
                                marginBottom: '15px'
                            }}
                        >
                            <Grid item xs={12}>
                                {IsUpdate ? (
                                    <Paper className={classes.PaperStyle}>
                                        <Grid container spacing={2}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialTextField
                                                    label="Name"
                                                    name="Name"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="Name"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialNumberField
                                                    label="Slat"
                                                    name="Slat"
                                                    type="text"
                                                    placeholder="Slat"
                                                    length={1}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialTextField
                                                    label="MerchantID"
                                                    name="MerchantID"
                                                    type="text"
                                                    placeholder="MerchantID"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialTextField
                                                    label="Token"
                                                    name="Token"
                                                    type="text"
                                                    placeholder="Token"
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialTextField
                                                    label="PublicKey"
                                                    name="PublicKey"
                                                    type="text"
                                                    placeholder="PublicKey"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialNumberField
                                                    label="Minimum Amount"
                                                    name="MinimumAmount"
                                                    type="text"
                                                    placeholder="Minimum Amount"
                                                    length={7}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialNumberField
                                                    label="Max Amount"
                                                    name="MaximumAmount"
                                                    type="text"
                                                    placeholder="Max Amount"
                                                    length={7}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialTextField
                                                    label="Mode"
                                                    name="Mode"
                                                    type="text"
                                                    placeholder="Mode"
                                                    length={5}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <FormikMaterialSwitch
                                                    label="IsActive"
                                                    name="IsActive"
                                                    onCustomCallback={(
                                                        name,
                                                        value
                                                    ) => {
                                                        OnChange(
                                                            name,
                                                            value,
                                                            formProps.setFieldValue
                                                        );
                                                    }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <PrimaryButton
                                                    type="submit"
                                                    title="Update"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loadingOpen}
                                                >
                                                    Update
                                                </PrimaryButton>
                                                {loadingOpen && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <SecondaryButton
                                                    type="reset"
                                                    title="Reset"
                                                    className={
                                                        classes.CustomDangerButtonStyle
                                                    }
                                                >
                                                    Reset
                                                </SecondaryButton>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                ) : null}
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
            <ReactTable
                data={itemList}
                columns={mainColumns}
                rowsPerPage={100}
            />

            {/* {itemList.map((item, index) => {
                if (dmtContentMap[item.Name]) {
                    return <div key={index}>{dmtContentMap[item.Name]}</div>;
                }
                return null;
            })} */}
        </CustomContainer>
    );
});
